import type {MapaCapabilityDto} from '@devmil/contracts';
import {useId} from 'react';

import {
  MAPA_CAPABILITY_CLASS,
  MAPA_CAPABILITY_LABEL,
  MAPA_CAPABILITY_REASON_LABEL,
} from '../../lib/format.js';

/**
 * O que o funil CONSEGUE fazer no processo que está de pé.
 *
 * Este bloco existe por causa do passo 2 do lote 09, e o defeito que ele fecha
 * é o mais fácil de não ver: a tela do MAPA mostrava etapa mudando e conversa
 * andando, e nada nela dizia que a pessoa do outro lado não recebe resposta
 * nenhuma. A máquina de estados anda, o estágio muda, o painel desenha, e o
 * efeito `send_template` é registrado no log e descartado.
 *
 * A ordem das linhas é o PERCURSO, e não a importância: a primeira desligada é
 * onde a conversa para. Quem lê de cima para baixo descobre onde o funil trava
 * sem precisar entender o código.
 *
 * Não usa classe nova nenhuma: `dm-checklist`, `dm-ok` e os dois modificadores
 * já desenham a lista da tela Operação. Um bloco novo com CSS novo obrigaria a
 * revisão visual a julgar desenho junto com informação, e o que mudou aqui é
 * informação.
 */
export const CapabilityList = ({
  capabilities,
}: {
  capabilities: readonly MapaCapabilityDto[];
}) => {
  const headingId = useId();
  const ativas = capabilities.filter((item) => item.active).length;

  return (
    <section className="dm-panel" aria-labelledby={headingId}>
      <div className="dm-panel-head">
        <h2 id={headingId}>Capacidades do funil</h2>
        {/*
          A contagem, e não um veredito.

          "O FUNIL RESPONDE" ou "NÃO RESPONDE" exigiria repetir aqui a regra de
          quais capacidades são necessárias, e a regra mora no domínio, do lado
          da API. Duas cópias divergiriam, e a da tela seria a que ninguém
          lembraria de atualizar. A contagem é aritmética sobre o que chegou.
        */}
        <span className="dm-illustrative">
          {ativas} DE {capabilities.length} ATIVAS
        </span>
      </div>
      <ul className="dm-checklist" aria-labelledby={headingId}>
        {capabilities.map((item) => (
          <li key={item.capability}>
            <span>{MAPA_CAPABILITY_LABEL[item.capability]}</span>
            <strong className={MAPA_CAPABILITY_CLASS[item.reason]}>
              {MAPA_CAPABILITY_REASON_LABEL[item.reason]}
            </strong>
          </li>
        ))}
      </ul>
    </section>
  );
};
